<label>
  <input [class.checked]="state" (click)="onChange($event)" type="checkbox" [disabled]="disabled" [ngModel]="state">
  <span class="slider round"></span>
</label>
<span>{{label}}</span>
